// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"94e844ae","787":"20f43eb3"}[chunkId] + ".chunk.js";
};